import { CRMConversationStatus } from "@jugl-web/rest-api/integrations/types";

export const reactivateClosedConversation = <
  T extends { conv_status?: CRMConversationStatus },
>(
  conversation: T
): T => {
  if (conversation.conv_status !== CRMConversationStatus.closed) {
    return conversation;
  }

  return {
    ...conversation,
    conv_status: CRMConversationStatus.active,
  };
};
